<template>
  <div
    class="vb-complete"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-if="data.question"
  >
    <div class="vb-complete-question">
      <div
        class="vb-complete-question-field"
        v-for="(word, index) in words"
        :key="`vb-word-${index}`"
      >
        <span
          v-if="word.type == 'text'"
        >
          {{ word.value }}
        </span>
        <input
          type="text"
          :style="{ width: `${word.size}px` }"
          :readonly="!!data.example"
          v-model="word.value"
          v-else-if="word.type == 'input'"
          @input="answerQuestion"
        >
      </div>
      <span></span>
    </div>
  </div>
  <div
    class="vb-complete-empty"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @load="(ev) => $emit('update')"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
    v-else
  >
    Complete phrase
  </div>
</template>
<script>
  import { cloneDeep } from 'lodash'

  export default {
    name: 'vb-exercise-complete',
    props: {
      data: {
        required: true
      },
      path: {
        required: true
      },
      draggable: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    },
    data () {
      return {
        words: [],
        timeout: null
      }
    },
    methods: {
      mountWords (question) {
        if (!question)
          return []

        const wordsToReplace = [ ...question.matchAll(/\#(.*?)\#/g) ]

        if (!wordsToReplace.length)
          return [ question ]

        const words = []

        const maxIndex = question.length

        let lastIndex = 0

        for (const i in wordsToReplace) {
          const match    = wordsToReplace[i],
                original = match[0],
                text     = match[1],
                index    = match.index

          if (lastIndex != index) {
            words.push({
              type: 'text',
              value: question.slice(lastIndex, index)
            })

            lastIndex = index
          }

          words.push({
            type: 'input',
            size: (text.length * (!this.data.example ? 14 : 8)) + 10,
            maxLength: text.length,
            value: !this.data.example ? '' : text
          })

          lastIndex = index + (original.length)

          if (i == (wordsToReplace.length - 1)) {
            if (lastIndex < maxIndex) {
              words.push({
                type: 'text',
                value: question.slice(lastIndex, maxIndex)
              })
            }
          }
        }

        return words
      },
      answerQuestion () {
        if (this.timeout)
          clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          this.$emit('answer', {
            prop: 'words',
            value: this.words,
            path: this.path
          })

          this.timeout = null
        }, 1500)
      }
    },
    watch: {
      data () {
        this.words = !this.data.words ? this.mountWords(this.data.question) : cloneDeep(this.data.words)
      }
    },
    beforeMount () {
      this.words = !this.data.words ? this.mountWords(this.data.question) : cloneDeep(this.data.words)
    }
  }
</script>
<style lang="scss" scoped>
  .vb-complete {
    font-size: 13px;
    // font-size: clamp(0em, 0.2em + 1vw, 1em);
    text-align: left;

    &-question {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      color: #670000;
      border: 2px solid #ffaa00;
      border-radius: 10px;
      font-weight: 600;
      padding: 10px 15px;

      &-field {
        margin: 2px 5px;

        input {
          border: none;
          border-bottom: 2px solid #000;
          padding: 0 5px;
          text-align: center;

          &:focus {
            outline: none;
          }
        }
      }
    }

    &.selected {
      border: .2rem dashed red;
    }
  }

  .vb-complete-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    margin: .5rem;
    height: 2rem;
    border: .2rem dashed brown;

    &.selected {
      border: .2rem dashed red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookExerciseComplete.vue